<div class="container custom">
    <mat-card>
        <a class="backtohome-td flex items-center color-white" [routerLink]="this.homeRoute"> <mat-icon>keyboard_arrow_left</mat-icon> Back To Home</a>
        <mat-card-content class="flex justify-center">
            
            <img class="not-found-image mt-5" src="/assets/img/illustrations/404-not-found.svg">
            
        </mat-card-content>
    </mat-card>
</div> 